export default "__VITE_ASSET__c1RBWZGF__"